import { useState } from "react";
import { Flag, Ban } from "lucide-react";
import { toast } from "sonner";
import { blockMember } from "@/lib/blocking";
import ReportModal from "./ReportModal";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Compact Report (+ optional Block) controls for reels, comments and DMs.
export default function ReportBlockControls({ targetType, targetId, authorId, testid, className = "", iconSize = 14, showBlock = true, onBlocked }) {
  const [reportOpen, setReportOpen] = useState(false);
  const [blockOpen, setBlockOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const block = async () => {
    setBusy(true);
    try {
      await blockMember(authorId, { onBlocked });
      setBlockOpen(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not block.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <button type="button" onClick={() => setReportOpen(true)} title="Report" data-testid={`${testid}-report`} className="text-zinc-400 hover:text-rose-400 p-1 transition-colors">
        <Flag size={iconSize} />
      </button>
      {showBlock && authorId && (
        <button type="button" onClick={() => setBlockOpen(true)} title="Block user" data-testid={`${testid}-block`} className="text-zinc-400 hover:text-rose-400 p-1 transition-colors">
          <Ban size={iconSize} />
        </button>
      )}
      <ReportModal open={reportOpen} onOpenChange={setReportOpen} target={{ type: targetType, id: targetId }} />
      <AlertDialog open={blockOpen} onOpenChange={setBlockOpen}>
        <AlertDialogContent className="bg-zinc-950 border-white/10 text-white rounded-none" data-testid={`${testid}-block-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display text-2xl">Block this user?</AlertDialogTitle>
            <AlertDialogDescription className="text-zinc-400 text-sm">They won&apos;t be able to message you, see your content, or find you in Social Meet. You can unblock later from Settings → Blocked.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-none bg-transparent border-white/15 text-zinc-300 hover:text-white">Cancel</AlertDialogCancel>
            <AlertDialogAction disabled={busy} onClick={block} data-testid={`${testid}-block-confirm`} className="rounded-none bg-rose-600 hover:bg-rose-500 text-white">Block</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </span>
  );
}
